module.exports = __webpack_public_path__ + "static/media/1.969a4944.jpg";